import React from 'react'

const Error = () => {
  return (
      <div className="font-size-xxs font-ui color-coral leading-ui14 margin-top-xxs">
        Vertippt? Bitte überprüf Deine E-Mail-Adresse.
      </div>
  );
}

export default Error
